export default {
  instructions:         'Para dar continuidade a sua solicitação precisamos confirmar as seguintes informações:',
  full_name_label:      'Nome completo',
  date_of_birth_label:  'Data de nascimento',
  cpf_label:            'CPF',
  mothers_name_label:   'Nome completo de mãe',
  required_field_label: '* Preenchimento obrigatório.',
};
